module.exports = __webpack_public_path__ + "assets/img/hero.1667f37c.jpg";